<template>
	<section class="gallery inner-screen">
		<div class="gallery__cont">
      <div class="gallery__item" v-for="(image, index) in images">
        <img :src="image" alt="">  
        <p v-html="imageTitle[index].title" style="line-height:1.2"></p>
      </div>
    </div>
	</section>	
</template>

<script>

export default {
  name: 'lithografia',
  created: function() {
      window.document.title = "ΓΚΑΛΕΡΙ - ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ";
  },
  data () {
    return {
      images: {},
      imageTitle: {
        0:{'title' : "Στρατής Αξιώτης<br><i>Ψαράς</i> 1938<br>Ξυλογραφία"},
        1:{'title' : "Δημήτρης Βιτσώρης<br><i>Κορίτσι</i> 1937<br>Λιθογραφία"},
        2:{'title' : "Άγγελος Θεοδωρόπουλος <br><i>Χωριάτισσα </i>1936<br>Ξυλογραφία"},
        3:{'title' : "Λυκούργος Κογεβίνας <br><i>Μονή Σταυρονικήτα</i> 1922<br>Οξυγραφία"},
        4:{'title' : "Αλέξανδρος Κορογιαννάκης <br><i>Θέρος</i> 1937<br>Ξυλογραφία"},
        5:{'title' : "Α. Τάσσος <br><i>Κορμός</i> 1938<br>Ξυλογραφία"},
        6:{'title' : "Γιάννης Κεφαλληνός <br><i>Μέγας Αλέξανδρος</i> 1937<br>Ξυλογραφία"},
        7:{'title' : "Γιώργος Βελισσαρίδης <br><i>Εκκλησάκι στη Σέριφο</i> 1960<br>Ξυλογραφία"},
        8:{'title' : "Λάμπρος Ορφανός <br><i>Κορίτσι με κόκκορα</i><br>"},
        9:{'title' : "Άννα Κινδύνη-Μαρουδή <br><i>Μητρότης</i> 1954-56<br>Οξυγραφία"},
        10:{'title' : "Γιάννης Κεφαλληνός <br><i>Φελάχος περ.</i> 1925-30<br>Λιθογραφία"},
        11:{'title' : "Βάσω Κατράκη <br><i>Ιππέας</i> 1964-66<br>Πετρογραφία (χάραξη σε ψαμμίτη λίθο)"},
        12:{'title' : "Δημήτρης Γαλάνης <br><i>Η Λήδα και ο κύκνος</i> 1936<br>Οξυγραφία"},
        13:{'title' : "Δημήτρης Γαλάνης <br><i>Οι Τρεις Χάριτες</i> 1923<br>Ξυλογραφία"},
        14:{'title' : "Μάρκος Ζαβιτσιάνος <br><i>Αγιογράφος εργαζόμενος</i> 1914-1920<br>Χαλκογραφία"},
        15:{'title' : "Δημήτρης Γιαννουκάκης <br><i>Καθιστό γυμνό περ.</i> 1955-1960<br>Έγχρωμη χαλκογραφία"},
        16:{'title' : "Αλέξανδρος Κορογιαννάκης <br><i>Δημοτικά έργα</i> 1936<br>Δίχρωμη ξυλογραφία"},
        17:{'title' : "Αλέξανδρος Κορογιαννάκης <br><i>Νεκρή φύση με λάμπα</i> 1958<br>Χαλκογραφία"}
      }
    }
  },
  mounted: function() {
    const importedImages = this.importAll(require.context('./../assets/img/gallery', true, /\.(png|jpe?g|svg)$/));
    this.images = importedImages;
    this.$emit('hideLoader')
  },
  methods: {
    importAll (r) {
      return r.keys().map(r);
    }
  }
}
</script>


// WEBPACK FOOTER //
// Gallery.vue?05d72ba3